"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MuscleRegime;
(function (MuscleRegime) {
    MuscleRegime["DYNAMIC"] = "DYNAMIC";
    MuscleRegime["ISOMETRIC"] = "ISOMETRIC";
    MuscleRegime["COMBINED"] = "COMBINED";
})(MuscleRegime || (MuscleRegime = {}));
exports.default = MuscleRegime;
//# sourceMappingURL=MuscleRegime.js.map